import React, { FC, ReactElement, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import classes from './AppBar.module.scss';
import { useLogout } from '../../hooks/entityHooks';

import { NavBar } from '../Navbar';
import { Context } from '../../services/context';

import pngLogo from '../../assets/images/NewLogo.svg';

// type Login = {
//   login: string;
// };
export const AppBar: FC = (): ReactElement => {
  const { logOut } = useLogout();
  const history = useHistory();
  const { setLogin, userData } = useContext(Context);

  const login = userData?.email;
  return (
    <>
      <div className={classes.body}>
        <div className={classes.body__container}>
          <div className={classes.body__container__pngLogo}>
            <img src={pngLogo} alt="" />
          </div>
          <NavBar />
          <div className={classes.body__container__loginInfo}>
            <p
              onClick={() => {
                history.push(`/user/${userData?.id}`);
              }}
            >
              Вошли как: <span>{login}</span>
            </p>

            <div
              onClick={(e) => {
                logOut();
                history.push('/login');
                if (setLogin) {
                  setLogin(false);
                }
              }}
              className={classes.body__container__logout}
            >
              Выйти
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
